import React from 'react';
import QueryForm from './QueryForm';
import { useParams } from 'react-router-dom';
import QueryContext from './query-context';
import { searchCatalog } from './query-utils';

export function QueryFormWrap() {
  const { id } = useParams()
  const { catalog} = React.useContext(QueryContext)
  const item = searchCatalog(id, catalog)
  //console.log('Inside QueryFormWrap: id', id);
  //console.log('Inside QueryFormWrap: item', item);

  return (
    <div className="container">
      <div className="layout-container content-container content-container--column content-container--shadow">

        <div className="content-display__container content-display__container--column align-center">
          <h1
            className="no-margin text-deep-blue text-center"
            data-test="header-text-device">
            {item?.title || 'Query Form'}
          </h1>
          <hr />
          <div
            className="content-display__container"
            data-test="content-container">
            <div
              className="content-display__column"
              data-test="active-unit-container">
              <div
                className="content-display__column"
                data-test="active-unit-container">
                <div className="content-display__item-pill-container">
                  <div className="item-container__main-container">
                    <QueryForm id={id} />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default QueryFormWrap;
